module.exports = __webpack_public_path__ + "img/plus.8774c5d0.svg";